import { useState } from 'react'

export default function Settings() {
  const [settings, setSettings] = useState(() => {
    // Load saved settings from localStorage
    const saved = localStorage.getItem('app-settings')
    if (saved) {
      try {
        return JSON.parse(saved)
      } catch {
        // Fall through to defaults
      }
    }
    return {
      apiKey: '',
      webhookUrl: '',
      notifications: true,
      autoDeploy: false
    }
  })
  const [saved, setSaved] = useState(false)

  const handleSave = () => {
    // Save settings to localStorage
    localStorage.setItem('app-settings', JSON.stringify(settings))
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Settings</h2>

      <div className="space-y-6 max-w-2xl">
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h3 className="text-lg font-semibold mb-4">API Configuration</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm text-gray-400 mb-1">API Key</label>
              <input
                type="password"
                value={settings.apiKey}
                onChange={e => setSettings({ ...settings, apiKey: e.target.value })}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-orange-500"
                placeholder="Enter your API key"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-1">Webhook URL</label>
              <input
                type="url"
                value={settings.webhookUrl}
                onChange={e => setSettings({ ...settings, webhookUrl: e.target.value })}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-orange-500"
                placeholder="https://example.com/webhook"
              />
            </div>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h3 className="text-lg font-semibold mb-4">Preferences</h3>
          <div className="space-y-4">
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={settings.notifications}
                onChange={e => setSettings({ ...settings, notifications: e.target.checked })}
                className="w-4 h-4 rounded border-gray-600 text-orange-500 focus:ring-orange-500"
              />
              <span className="text-sm">Enable Notifications</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={settings.autoDeploy}
                onChange={e => setSettings({ ...settings, autoDeploy: e.target.checked })}
                className="w-4 h-4 rounded border-gray-600 text-orange-500 focus:ring-orange-500"
              />
              <span className="text-sm">Auto-deploy on push</span>
            </label>
          </div>
        </div>

        <button
          onClick={handleSave}
          className={`px-6 py-2 rounded-lg transition-colors ${
            saved
              ? 'bg-green-500 hover:bg-green-600'
              : 'bg-orange-500 hover:bg-orange-600'
          }`}
        >
          {saved ? '已保存!' : '保存设置'}
        </button>
      </div>
    </div>
  )
}
